<template>
  <div>
    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.firstStep.advisory_id.$error }" v-if="!disabled">
          <label>Review Reference</label>
          <md-select v-model="firstStep.advisory_id" :disabled="disabled" md-dense>
            <md-option :value="arr.id" :key="i" v-for="(arr, i) in arrs">
              {{ arr.reference }}
            </md-option>
          </md-select>
        </md-field>
        <md-field v-else>
          <label>Review Reference</label>
          <md-input :disabled="disabled" v-model="firstStep.advisory.reference"/>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-field :class="{ 'md-error': $v.firstStep.rqr_type.$error }" v-if="!disabled">
          <label>RQR Type</label>
          <md-select v-model="firstStep.rqr_type" disabled md-dense>
            <md-option :value="code" :key="code" v-for="(type, code) in rqrTypesMap">
              {{ type }}
            </md-option>
          </md-select>
        </md-field>
        <md-field v-else>
          <label>RQR Type</label>
          <md-input :disabled="disabled" :value="firstStep.advisory.rqr_type | rqrType"/>
        </md-field>
      </div>
    </div>
    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.firstStep.rqr_leader_id.$error }" v-if="!disabled">
          <label>Risk and Quality Review Leader</label>
          <md-select v-model="firstStep.rqr_leader_id" disabled md-dense>
            <md-option :value="user.id" :key="i" v-for="(user, i) in users">
              {{ user.name }}
            </md-option>
          </md-select>
        </md-field>
        <md-field v-else>
          <label>Risk and Quality Review Leader</label>
          <md-input :disabled="disabled" v-model="firstStep.advisory.leader.name"/>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.firstStep.fiscal_year.$error }">
          <label>Fiscal Year</label>
          <md-input v-model="firstStep.fiscal_year" disabled />
        </md-field>
      </div>
    </div>
    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field>
          <label>Review Status</label>
          <md-select v-model="firstStep.status" disabled md-dense>
            <md-option :key="i" :value="i" v-for="(status, i) in reviewStatusMap">
              {{ status }}
            </md-option>
          </md-select>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.firstStep.cluster.$error }">
          <label>Cluster</label>
          <md-select v-model="firstStep.cluster" :disabled="isSaving || !canEdit" md-dense>
            <md-option :value="cluster.id" :key="i" v-for="(cluster, i) in clusters">
              {{ cluster.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.firstStep.engagement_leader_id.$error }">
          <label :class="'title-select'" >Engagement Leader (EL)</label>
          <select :class="'custom-select'" placeholder="Engagement Leader (EL)" 
            v-model="firstStep.engagement_leader_id" :disabled="isSaving || !canEdit" md-dense>
            <option value="null">Engagement Leader</option>
            <option :value="user.id" v-for="(user, i) in users" :key="i">
              {{ user.name }}
            </option>
          </select>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-field>
          <label :class="'title-select'">
            Director, if applicable
          </label>
          <select :class="'custom-select'" placeholder="Director" v-model="firstStep.director_id"
            :disabled="isSaving || !canEdit" md-dense>
            <option value="null">Director</option>
            <option :value="user.id" v-for="(user, i) in users" :key="i">
              {{ user.name }}
            </option>
          </select>
        </md-field>
      </div>
    </div>
    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.firstStep.manager_engagement_id.$error }">
          <label :class="'title-select'">Manager of the Engagement</label>
          <select :class="'custom-select'" placeholder="Manager of the Engagement"
            v-model="firstStep.manager_engagement_id" :disabled="isSaving || !canEdit" md-dense>
            <option value="null">Manager of the Engagement</option>
            <option :value="user.id" v-for="(user, i) in users" :key="i">
              {{ user.name }}
            </option>
          </select>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.firstStep.rqr_reviewer_id.$error }">
          <label :class="'title-select'">RQR Reviewer</label>
          <select :class="'custom-select'" placeholder="RQR Reviewer" v-model="firstStep.rqr_reviewer_id"
            :disabled="isSaving || !canEdit" md-dense>
            <option value="null">RQR Reviewer</option>
            <option :value="user.id" v-for="(user, i) in users" :key="i">
              {{ user.name }}
            </option>
          </select>
        </md-field>
      </div>
    </div>
    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field>
          <label :class="'title-select'" >Quality Review Partner (QRP)</label>
          <select :class="'custom-select'" placeholder="Quality Review Partner"
            v-model="firstStep.quality_review_partner_id" :disabled="isSaving || !canEdit" md-dense>
            <option value="null">Quality Review Partner (QRP)</option>
            <option :value="user.id" v-for="(user, i) in users" :key="i">
              {{ user.name }}
            </option>
          </select>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-field :class="{ 'md-error': $v.firstStep.review_code.$error }">
          <label>
            Review Code <small v-if="!$v.firstStep.review_code.maxLength">Exceeded max 20 characters</small>
          </label>
          <md-input :disabled="isSaving || !canEdit" v-model="firstStep.review_code" />
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import { rqrType } from "@/filters";
import { rqrTypesMap } from "@/filters/rqrType";
import { reviewStatusMap } from "@/filters/reviewStatus";
import { maxLength, required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      firstStep: {
        advisory_id: null,
        rqr_leader_id: "",
        cluster: 1,
        rqr_type: "",
        fiscal_year: "",
        status: 1,
        engagement_leader_id: null,
        director_id: null,
        manager_engagement_id: null,
        rqr_reviewer_id: null,
        quality_review_partner_id: null,
        review_code: null,
        type: 2,
        engagementLeader: {},
        managerEngagement: {},
        rqrReviewer: {},
        director: {},
        advisory: { leader: {} },
      },
      rqrTypesMap,
      reviewStatusMap,
    };
  },

  mounted() {
    this.enableClearField();
  },

  filters: {
    rqrType,
  },

  methods: {
    enableClearField() {
      document
        .querySelectorAll(".md-field.md-clearable.md-datepicker")
        .forEach((closeEl) => {
          closeEl.addEventListener("click", (e) => {
            if (e.target.classList.contains("md-ripple") || e.target.closest(".md-ripple")) 
              this.firstStep[closeEl.dataset.model] = null;            
          });
        });
    },

    validate() {
      this.$v.firstStep.$touch();
      this.$emit("validate", !this.$v.firstStep.$invalid, this.firstStep, false);
      return !this.$v.firstStep.$invalid;
    },
    
  },

  props: {
    users: {
      type: Array,
      default: () => [],
      required: true,
    },
    clusters: {
      type: Array,
      default: () => [],
      required: true,
    },
    arrs: {
      type: Array,
      default: () => [],
      required: true,
    },
    fetchedARQR: {
      type: Object,
      default: () => {},
      required: false,
    },
    mode: {
      type: String,
      default: () => "",
      required: false,
    },
    disabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    isSaving: {
      type: Boolean,
      required: false,
      default: false,
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  validations: {
    firstStep: {
      advisory_id: { required },
      rqr_leader_id: { required },
      rqr_type: { required },
      cluster: { required },
      fiscal_year: { required },
      engagement_leader_id: { required },
      manager_engagement_id: { required },
      review_code: { maxLength: maxLength(20), required },
      rqr_reviewer_id: { required },
    },
  },

  watch: {
    "firstStep.advisory_id": function () {
      if (this.mode === "viewing")
        return;
      
      const advisory = this.arrs.find((arr) => this.firstStep.advisory_id === arr.id);
      if (advisory) {
        this.firstStep.rqr_type = advisory.rqr_type;
        this.firstStep.rqr_leader_id = advisory.rqr_leader;
        this.firstStep.fiscal_year = advisory.fiscal_year;
      }
    },

    fetchedARQR: function () {
      this.firstStep = this.fetchedARQR;
      this.firstStep.advisory_id = this.fetchedARQR.advisory.id;
      this.firstStep.rqr_leader_id = this.fetchedARQR.advisory.rqr_leader;
      this.firstStep.rqr_type = this.fetchedARQR.advisory.rqr_type;
      this.firstStep.fiscal_year = this.fetchedARQR.advisory.fiscal_year;
      this.firstStep.cluster = this.fetchedARQR.cluster;
      this.firstStep.director = this.fetchedARQR.director ? this.fetchedARQR.director : {};
    },
  },
};
</script>